import instance from 'src/common/http/axiosInstance';
import { mapToData } from 'src/common/http/mapToData';
import { mapToErrors } from 'src/common/http/mapToErrors';

import { ListProjectTierUsersQueryDTO, ListProjectTierUsersResponseDTO } from './dtos';

export const tierUsersService = {
  list: async (
    projectId: string,
    tierId: string,
    query: ListProjectTierUsersQueryDTO = {},
  ): Promise<ListProjectTierUsersResponseDTO> => {
    const params: Record<string, string | number> = {};
    if (query.tab) params.tab = query.tab;
    if (query.q) params.q = query.q;
    if (query.page) params.page = query.page;
    if (query.per_page) params.per_page = query.per_page;

    return instance
      .get<ListProjectTierUsersResponseDTO>(`projects/${projectId}/tiers/${tierId}/users`, { params })
      .then(mapToData)
      .catch(mapToErrors);
  },
};
